// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/order_trade/entity/v1/market_mover.proto (package financial.order_trade.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum financial.order_trade.entity.v1.MoverType
 */
export const MoverType = /*@__PURE__*/ proto3.makeEnum(
  "financial.order_trade.entity.v1.MoverType",
  [
    {no: 0, name: "MOVER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MOVER_TYPE_TOP_VALUE", localName: "TOP_VALUE"},
    {no: 2, name: "MOVER_TYPE_TOP_VOLUME", localName: "TOP_VOLUME"},
    {no: 3, name: "MOVER_TYPE_TOP_FREQUENCY", localName: "TOP_FREQUENCY"},
    {no: 4, name: "MOVER_TYPE_TOP_GAINER", localName: "TOP_GAINER"},
    {no: 5, name: "MOVER_TYPE_TOP_LOSER", localName: "TOP_LOSER"},
    {no: 6, name: "MOVER_TYPE_NET_FOREIGN_BUY", localName: "NET_FOREIGN_BUY"},
    {no: 7, name: "MOVER_TYPE_NET_FOREIGN_SELL", localName: "NET_FOREIGN_SELL"},
  ],
);

/**
 * @generated from enum financial.order_trade.entity.v1.FilterStocksType
 */
export const FilterStocksType = /*@__PURE__*/ proto3.makeEnum(
  "financial.order_trade.entity.v1.FilterStocksType",
  [
    {no: 0, name: "FILTER_STOCKS_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FILTER_STOCKS_TYPE_MAIN_BOARD", localName: "MAIN_BOARD"},
    {no: 2, name: "FILTER_STOCKS_TYPE_DEVELOPMENT_BOARD", localName: "DEVELOPMENT_BOARD"},
    {no: 3, name: "FILTER_STOCKS_TYPE_ACCELERATION_BOARD", localName: "ACCELERATION_BOARD"},
    {no: 4, name: "FILTER_STOCKS_TYPE_NEW_ECONOMY_BOARD", localName: "NEW_ECONOMY_BOARD"},
    {no: 5, name: "FILTER_STOCKS_TYPE_SPECIAL_MONITORING_BOARD", localName: "SPECIAL_MONITORING_BOARD"},
    {no: 6, name: "FILTER_STOCKS_TYPE_WARRANT_AND_RIGHT", localName: "WARRANT_AND_RIGHT"},
    {no: 7, name: "FILTER_STOCKS_TYPE_SHARIA", localName: "SHARIA"},
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover
 */
export const MarketMover = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover",
  () => [
    { no: 1, name: "stock_detail", jsonName: "stock_detail", kind: "message", T: MarketMover_StockDetail },
    { no: 2, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "change", kind: "message", T: Change },
    { no: 4, name: "value", kind: "message", T: MoverValue },
    { no: 5, name: "volume", kind: "message", T: MoverValue },
    { no: 6, name: "frequency", kind: "message", T: MoverValue },
    { no: 7, name: "net_foreign_buy", jsonName: "net_foreign_buy", kind: "message", T: MoverValue },
    { no: 8, name: "net_foreign_sell", jsonName: "net_foreign_sell", kind: "message", T: MoverValue },
    { no: 9, name: "net_buy", jsonName: "net_buy", kind: "message", T: MoverValue },
    { no: 10, name: "net_sell", jsonName: "net_sell", kind: "message", T: MoverValue },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover.NotationDetail
 */
export const MarketMover_NotationDetail = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover.NotationDetail",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "MarketMover_NotationDetail"},
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover.CorpactionDetail
 */
export const MarketMover_CorpactionDetail = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover.CorpactionDetail",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "MarketMover_CorpactionDetail"},
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMover.StockDetail
 */
export const MarketMover_StockDetail = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.MarketMover.StockDetail",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "has_uma", jsonName: "has_uma", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "notations", kind: "message", T: MarketMover_NotationDetail, repeated: true },
    { no: 6, name: "corpaction", kind: "message", T: MarketMover_CorpactionDetail },
  ],
  {localName: "MarketMover_StockDetail"},
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMoverBatch
 */
export const MarketMoverBatch = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.MarketMoverBatch",
  () => [
    { no: 1, name: "batch", kind: "message", T: MarketMover, repeated: true },
    { no: 2, name: "mover_type", jsonName: "mover_type", kind: "enum", T: proto3.getEnumType(MoverType) },
    { no: 3, name: "filter_stocks", jsonName: "filter_stocks", kind: "enum", T: proto3.getEnumType(FilterStocksType), repeated: true },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.Change
 */
export const Change = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.Change",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MoverValue
 */
export const MoverValue = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.MoverValue",
  () => [
    { no: 1, name: "raw", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "formatted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.order_trade.entity.v1.MarketMoverWebsocketRequest
 */
export const MarketMoverWebsocketRequest = /*@__PURE__*/ proto3.makeMessageType(
  "financial.order_trade.entity.v1.MarketMoverWebsocketRequest",
  () => [
    { no: 1, name: "mover_type", jsonName: "mover_type", kind: "enum", T: proto3.getEnumType(MoverType) },
    { no: 2, name: "filter_stocks", jsonName: "filter_stocks", kind: "enum", T: proto3.getEnumType(FilterStocksType), repeated: true },
  ],
);

